/* OLD ORDER「マイシューズ」（2026-10-25 見本・開発係）
 *  テーマ（snippets/oo-my-shoes-data.liquid）が出す小さな JSON（買った靴のハンドル・商品名・ブランド・URL・画像だけ）を読んで、
 *  ガラスのショーケースに並べる。空いた棚には「次に並べたい1足」（在庫のある靴）を入れる。
 *  「画像で保存」は別の部品 assets/oo-myshoes-share.js の window.ooMyShoesShare({items:[{img,title}], bgUrl}) を呼ぶだけ。
 *  使う店の API は、だれでも見られるもの（/collections/<handle>/products.json）だけ。会員の情報は送らない。
 *  棚は1段3足×3段（9足をこえたら段を足す）。
 */
(function () {
  "use strict";
  var BRAND_NAME = { oldorder: "OLD ORDER", ocai: "Ocai", bbimp: "BBiMP" };

  function nk(s) { return String(s || "").normalize("NFKC").toLowerCase().replace(/[^a-z0-9]/g, ""); }
  function brandKey(v) { var k = nk(v); return k.indexOf("oldorder") === 0 ? "oldorder" : k; }
  function brandName(v) { var k = brandKey(v); return BRAND_NAME[k] || String(v || ""); }
  // 「【BBIMP】【Ocai】Armored Football Shoes / Silver」のように【】が2つ以上ある商品もあるので、全部はずす
  function plainTitle(t) { return String(t || "").replace(/【[^】]*】\s*/g, "").trim(); }
  function seriesOf(t) { return plainTitle(t).split(/\s*\/\s*/)[0].trim(); }
  function colorOf(t) { var p = plainTitle(t).split(/\s*\/\s*/); return p.length > 1 ? p.slice(1).join(" / ").trim() : ""; }
  function keyOf(p) { return nk(seriesOf(p.t)) + "|" + nk(colorOf(p.t)); }
  function sized(url, w) {
    if (!url) return "";
    var u = String(url);
    if (u.indexOf("//") === 0) u = location.protocol + u;
    if (/[?&]width=\d+/.test(u)) return u.replace(/([?&]width=)\d+/, "$1" + w);
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=" + w;
  }
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  function words(s) { return String(s || "").toLowerCase().split(",").map(function (w) { return w.trim(); }).filter(Boolean); }
  function hasWord(p, list) {
    var hay = [p.t, p.b, p.type, (p.tags || []).join ? (p.tags || []).join(" ") : p.tags].join(" ").toLowerCase();
    for (var i = 0; i < list.length; i++) if (list[i] && hay.indexOf(list[i]) >= 0) return true;
    return false;
  }

  function init(root) {
    if (root.__ooMyShoes) return;
    var raw = root.querySelector(".oo-myshoes__data");
    var data = {};
    try { data = JSON.parse(raw ? raw.textContent : "{}"); } catch (e) { data = {}; }
    var cfg = {
      login: root.getAttribute("data-login-url") || "/customer_authentication/login",
      minSlots: Math.max(3, parseInt(root.getAttribute("data-min-slots"), 10) || 9),
      nextCount: Math.max(0, parseInt(root.getAttribute("data-next-count"), 10) || 0),
      brands: (root.getAttribute("data-brands") || "OLD ORDER,OCAI,BBIMP").split(",").map(function (s) { return s.trim(); }).filter(Boolean),
      nextSkip: words(root.getAttribute("data-next-skip")),
      collections: (root.getAttribute("data-collections") || "oldorder-all,ocai-all,bbimp-all").split(",").map(function (s) { return s.trim(); }).filter(Boolean).slice(0, 4),
      heading: root.getAttribute("data-heading") || "MY SHOES",
      lead: root.getAttribute("data-lead") || "",
      bgUrl: root.getAttribute("data-bg-url") || "",
      logoUrl: root.getAttribute("data-logo-url") || "",
      eventUrl: root.getAttribute("data-event-url") || ""
    };
    // 背景画像の住所はここ1か所（セクションの data-bg-url。ふだんはテーマの assets/oo-myshoes-showcase.jpg、設定で別の画像も選べる）。
    //  空なら CSS の仮の背景（暗い木目＋ガラスの光り）。「画像で保存」にも同じ画像を bgUrl で渡す
    if (cfg.bgUrl) root.style.setProperty("--oo-case-bg-image", 'url("' + cfg.bgUrl.replace(/"/g, "%22") + '")');
    var block = (data.words || []).map(function (w) { return String(w).trim(); }).filter(Boolean);
    var owned = (data.items || []).filter(function (p) { return p && p.h && !hasWord(p, block); });
    var api = { data: data, owned: owned, picks: [], ready: null };
    root.__ooMyShoes = api;
    var ui = {};

    root.innerHTML = "";
    if (raw) root.appendChild(raw);
    var head = el("header", "oo-myshoes__head");
    head.appendChild(el("p", "oo-myshoes__eyebrow", "OLD ORDER"));
    head.appendChild(el("h1", "oo-myshoes__title", cfg.heading));
    head.appendChild(el("span", "oo-myshoes__bar"));
    if (data.in && owned.length) {
      var c = el("p", "oo-myshoes__count");
      c.appendChild(el("b", null, String(owned.length)));
      c.appendChild(document.createTextNode(owned.length === 1 ? "PAIR" : "PAIRS"));
      head.appendChild(c);
    } else if (cfg.lead) {
      head.appendChild(el("p", "oo-myshoes__lead", cfg.lead));
    }
    root.appendChild(head);

    // 棚は1段3足×3段＝9マスで1つのケース。9足をこえたらケースを下に足す
    var cols = 3, perCase = 9;
    var photo = !!cfg.bgUrl;
    var nextN = data.in ? cfg.nextCount : 0;
    var slots = Math.max(perCase, Math.ceil((owned.length + nextN) / perCase) * perCase);
    var free = slots - owned.length;
    nextN = Math.min(nextN, free);

    var nextSlots = [], cse = null, grid = null;
    for (var i = 0; i < slots; i++) {
      if (i % perCase === 0) {
        cse = el("div", "oo-case" + (photo ? " oo-case--photo" : "") + (data.in ? "" : " oo-case--locked"));
        if (!photo) cse.appendChild(el("div", "oo-case__light"));
        grid = el("div", "oo-case__grid");
        grid.style.setProperty("--cols", cols);
        // テーマの「お気に入りのハートを自動で付ける」しくみ（theme.liquid の injectMissingHearts）は、同じ入れ物に .oo-card-wish があると付けない。
        //  棚の靴にハートが重なって名前が隠れるので、見えない印を1つ置いて付けないようにする
        var noWish = el("i", "oo-card-wish oo-myshoes__nowish");
        noWish.hidden = true;
        noWish.setAttribute("aria-hidden", "true");
        grid.appendChild(noWish);
        cse.appendChild(grid);
        if (!photo) cse.appendChild(el("div", "oo-case__base", "OLD ORDER"));
        if (!data.in) cse.appendChild(lockCard(cfg));
        root.appendChild(cse);
      }
      var s;
      if (i < owned.length) s = ownedSlot(owned[i]);
      else if (i < owned.length + nextN) { s = emptySlot(true); nextSlots.push(s); }
      else s = emptySlot(false);
      if ((i + 1) % cols === 0) s.classList.add("is-last-col");
      if (photo) placeOnPhoto(s, i % perCase);
      grid.appendChild(s);
    }

    if (data.in) {
      if (nextN) {
        var lg = el("p", "oo-myshoes__legend");
        lg.appendChild(el("span", "oo-slot__tag", "NEXT"));
        lg.appendChild(document.createTextNode(owned.length ? "次に並べたい1足（いま在庫のある靴・押すと商品ページへ）" : "最初の1足にいかがですか（いま在庫のある靴・押すと商品ページへ）"));
        root.appendChild(lg);
      }
      if (owned.length) {
        root.appendChild(shareBox());
      } else {
        root.appendChild(el("p", "oo-myshoes__note", "まだ棚は空いています。ネットでお買い上げいただいた靴が、ここに並びます。"));
      }
    }
    root.appendChild(el("p", "oo-myshoes__fine", "※ いまは、オンラインストアでお買い上げいただいた靴が並びます（キャンセル・返品した靴は並びません）。お店でお買い上げの靴は、これから並べられるようにします。"));

    api.ready = nextN ? choosePicks(owned, cfg, block, nextN, data.picks || []).then(function (picks) {
      api.picks = picks;
      nextSlots.forEach(function (slot, k) {
        var p = picks[k];
        if (p) slot.parentNode.replaceChild(nextSlot(p, slot), slot);
        else { slot.classList.remove("oo-slot--wait", "oo-slot--next"); slot.classList.add("oo-slot--empty"); }
      });
      return picks;
    }).catch(function () { nextSlots.forEach(function (slot) { slot.classList.remove("oo-slot--wait"); }); return []; }) : Promise.resolve([]);

    // ---- 画像とシェア ----
    //  保存用（1080×1350）は別の部品 assets/oo-myshoes-share.js（係C）が描く。渡すのは靴の画像と商品名だけ（最大9足・新しい順）
    //  ストーリー用（1080×1920）は、その絵を真ん中に置いて作る（上 250px・下 300px はインスタの部品で隠れるので何も置かない）
    //  iPhone は「押した直後」でないと共有の画面が開かないので、ページを開いたときに両方とも描いて、ファイルにまでしておく
    api.shareArgs = function () {
      return { items: owned.slice(0, 9).map(function (p) { return { img: sized(p.i, 800), title: plainTitle(p.t) }; }), bgUrl: cfg.bgUrl, logoUrl: cfg.logoUrl };
    };
    api.canvas = null; api.story = null; api.files = null;

    function share() { return typeof window.ooMyShoesShare === "function" ? window.ooMyShoesShare : null; }
    function prerender() {
      var S = share();
      if (!owned.length || !S || typeof S.render !== "function" || api.canvas) return;
      try {
        S.render(api.shareArgs(), function (canvas) {
          if (!canvas) return;
          api.canvas = canvas;
          api.story = makeStory(canvas);
          toFile(canvas, "oldorder-my-shoes.png", function (f1, b1) {
            toFile(api.story, "oldorder-my-shoes-story.png", function (f2) {
              api.files = { post: f1, story: f2 };
              if (ui.thumb && b1) { ui.thumb.src = URL.createObjectURL(b1); ui.thumb.hidden = false; }
              if (ui.status) { ui.status.textContent = ""; ui.status.appendChild(el("span", null, "画像ができました。")); ui.status.appendChild(el("span", null, "載せる先を選んでください。")); }
            });
          });
        });
      } catch (e) { /* 押したときに作り直す */ }
    }
    if (data.in && owned.length) {
      if (share()) prerender();
      else window.addEventListener("load", prerender);
    }
    function say(t) { if (ui.msg) { ui.msg.textContent = t; ui.msg.hidden = !t; } }
    function notReady() { say("画像を準備しています。数秒たってから、もう一度押してください。"); }
    function canShare(file) { return !!(file && navigator.share && navigator.canShare && navigator.canShare({ files: [file] })); }
    function shareBox() {
      var box = el("div", "oo-share");
      box.appendChild(el("p", "oo-share__title", "SHARE"));
      var head = el("div", "oo-share__head");
      ui.thumb = el("img", "oo-share__thumb"); ui.thumb.alt = "保存される画像"; ui.thumb.hidden = true;
      head.appendChild(ui.thumb);
      ui.status = el("p", "oo-share__status", "画像を準備しています…");
      head.appendChild(ui.status);
      box.appendChild(head);
      // 1 インスタのストーリー（9:16 の画像を共有の画面へ。Instagram を選ぶと「ストーリーズ」に進める）
      var bStory = el("button", "oo-btn oo-btn--story", "インスタのストーリーに載せる"); bStory.type = "button";
      bStory.addEventListener("click", function () {
        track("share_story");
        var f = api.files && api.files.story;
        if (!f) return notReady();
        say("");
        if (canShare(f)) { navigator.share({ files: [f] }).catch(function () {}); return; }
        download(f);
        say("画像を保存しました。インスタのストーリーを開いて、保存した画像を選んでください。");
      });
      // 2 X（1080×1350 の画像を共有の画面へ。できない端末は X の投稿画面を開く）
      var bX = el("button", "oo-btn oo-btn--ghost", "Xでシェア"); bX.type = "button";
      bX.addEventListener("click", function () {
        track("share_x");
        var f = api.files && api.files.post;
        if (f && canShare(f)) { say(""); navigator.share({ files: [f], text: X_TEXT + " " + X_URL }).catch(function () {}); return; }
        window.open("https://x.com/intent/post?text=" + encodeURIComponent(X_TEXT) + "&url=" + encodeURIComponent(X_URL), "_blank", "noopener");
      });
      // 3 画像を保存（今までの動き＝係Cの部品の save）
      var bSave = el("button", "oo-btn oo-btn--ghost", "画像を保存"); bSave.type = "button";
      bSave.addEventListener("click", function () { track("save"); saveImage(bSave); });
      box.appendChild(bStory); box.appendChild(bX); box.appendChild(bSave);
      ui.msg = el("p", "oo-share__msg"); ui.msg.hidden = true;
      box.appendChild(ui.msg);
      return box;
    }
    function saveImage(b) {
      var S = share();
      if (!S) return notReady();
      say("");
      if (api.canvas && typeof S.save === "function") { S.save(api.canvas); return; }
      // まだ描き終わっていない → 部品が重ねて出す画面に自動で切りかわる
      var old = b.textContent;
      b.disabled = true;
      b.textContent = "画像をつくっています…";
      try {
        S(api.shareArgs(), function () { b.disabled = false; b.textContent = old; });
      } catch (e) {
        b.disabled = false; b.textContent = old;
        say("画像をつくれませんでした。時間をおいて、もう一度お試しください。");
      }
      setTimeout(function () { b.disabled = false; b.textContent = old; }, 15000);
    }
    // 押された数（送り先はここ1か所: data-event-url。空のあいだは dataLayer に積むだけ。会員の情報は送らない）
    function track(name) {
      var ev = { event: "oo_myshoes_" + name, page: "my-shoes", pairs: owned.length };
      try { if (window.dataLayer && window.dataLayer.push) window.dataLayer.push(ev); } catch (e) {}
      try { if (cfg.eventUrl && navigator.sendBeacon) navigator.sendBeacon(cfg.eventUrl, new Blob([JSON.stringify({ type: ev.event, page: ev.page, pairs: ev.pairs })], { type: "text/plain" })); } catch (e) {}
    }
  }

  var X_TEXT = "わたしのMY SHOES #OLDORDER", X_URL = "https://oldorder.jp/pages/my-shoes";
  // ストーリー用 1080×1920。保存用の絵を少し縮めて真ん中に置く（上 250px・下 300px には何も置かない）
  function makeStory(src) {
    var W = 1080, H = 1920, TOP = 250, BOTTOM = 300;
    var c = document.createElement("canvas"); c.width = W; c.height = H;
    var x = c.getContext("2d");
    var g = x.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, "#f5f6f7"); g.addColorStop(1, "#e6e9eb");
    x.fillStyle = g; x.fillRect(0, 0, W, H);
    var room = H - TOP - BOTTOM - 40;
    var s = Math.min((W - 40) / src.width, room / src.height);
    var dw = Math.round(src.width * s), dh = Math.round(src.height * s);
    var dx = Math.round((W - dw) / 2), dy = Math.round(TOP + 20 + (room - dh) / 2);
    x.save(); x.shadowColor = "rgba(0,0,0,0.14)"; x.shadowBlur = 40; x.shadowOffsetY = 14;
    x.fillStyle = "#ffffff"; x.fillRect(dx, dy, dw, dh); x.restore();
    x.drawImage(src, dx, dy, dw, dh);
    return c;
  }
  function toFile(canvas, name, cb) {
    function done(blob) {
      var f = null;
      try { f = blob ? new File([blob], name, { type: "image/png" }) : null; } catch (e) { f = null; }
      cb(f, blob);
    }
    try { if (canvas.toBlob) return canvas.toBlob(done, "image/png"); } catch (e) {}
    done(null);
  }
  function download(file) {
    var a = document.createElement("a");
    var url = URL.createObjectURL(file);
    a.href = url; a.download = file.name || "oldorder-my-shoes.png"; a.style.display = "none";
    document.body.appendChild(a); a.click();
    setTimeout(function () { a.remove(); URL.revokeObjectURL(url); }, 4000);
  }

  // 背景画像（showcase_portrait.png・1080×1350・3列×3段）の上の9マスの位置（％）。画像を見て決めた値。画像を変えたらここだけ直す
  //  x＝列の中心（左から）、shelf＝靴を乗せる棚板の上の面（上から）、top＝名前の札を出す高さ（上から）
  var PHOTO = { x: [19.4, 50.0, 80.6], shelf: [30.6, 57.2, 86.2], top: [7.6, 34.4, 61.4] };
  function placeOnPhoto(s, k) {
    var c = k % 3, r = Math.floor(k / 3);
    s.style.setProperty("--x", PHOTO.x[c] + "%");
    s.style.setProperty("--shelf", PHOTO.shelf[r] + "%");
    s.style.setProperty("--top", PHOTO.top[r] + "%");
  }
  function label(top, sub) {
    var l = el("span", "oo-slot__label", top || " ");
    l.appendChild(el("small", null, sub || " "));
    return l;
  }
  function ownedSlot(p) {
    var a = el("a", "oo-slot oo-slot--owned");
    a.href = p.u || ("/products/" + p.h);
    var box = el("span", "oo-slot__box");
    var img = new Image();
    img.alt = plainTitle(p.t);
    img.loading = "lazy";
    img.decoding = "async";
    img.src = sized(p.i, 400);
    box.appendChild(img);
    a.appendChild(box);
    a.appendChild(label(seriesOf(p.t), colorOf(p.t)));
    a.appendChild(el("span", "oo-slot__shelf"));
    return a;
  }
  function emptySlot(wait) {
    var d = el("div", "oo-slot " + (wait ? "oo-slot--wait" : "oo-slot--empty"));
    d.appendChild(el("span", "oo-slot__box"));
    d.appendChild(label("", ""));
    d.appendChild(el("span", "oo-slot__shelf"));
    return d;
  }
  function nextSlot(p, old) {
    var a = el("a", "oo-slot oo-slot--next" + (old.classList.contains("is-last-col") ? " is-last-col" : ""));
    a.style.cssText = old.style.cssText;
    a.href = p.u || ("/products/" + p.h);
    a.setAttribute("aria-label", "次に並べたい1足: " + plainTitle(p.t));
    var box = el("span", "oo-slot__box");
    box.appendChild(el("span", "oo-slot__tag", "NEXT"));
    var img = new Image();
    img.alt = plainTitle(p.t);
    img.decoding = "async";
    img.src = sized(p.i, 400);
    box.appendChild(img);
    a.appendChild(box);
    a.appendChild(label(seriesOf(p.t), p.why));
    a.appendChild(el("span", "oo-slot__shelf"));
    return a;
  }
  function lockCard(cfg) {
    var d = el("div", "oo-lock");
    d.appendChild(el("span", "oo-lock__icon"));
    var tt = el("p", "oo-lock__title");
    tt.appendChild(el("span", null, "ログインすると、"));
    tt.appendChild(el("span", null, "買った靴が棚に並びます"));
    d.appendChild(tt);
    d.appendChild(el("p", "oo-lock__text", "オンラインストアでお買い上げいただいた靴が、あなただけのショーケースに並びます。はじめての方も、メールアドレスで会員登録できます。"));
    var a = el("a", "oo-btn", "ログイン / 会員登録");
    a.href = cfg.login;
    d.appendChild(a);
    return d;
  }

  // ---- 次に並べたい1足 ----
  //  だれでも見られるコレクションの商品一覧（/collections/<handle>/products.json）だけを読む。会員の情報は送らない。
  //  ※ お店の予測検索（/search/suggest.json）は日本語のお店では使えない（417 Unsupported buyer locale・2026-10-25 確認）
  function loadCollection(h) {
    return fetch("/collections/" + encodeURIComponent(h) + "/products.json?limit=250", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        return ((j && j.products) || []).map(function (x) {
          var vs = x.variants || [];
          return {
            h: x.handle, t: x.title, b: x.vendor, u: "/products/" + x.handle,
            i: (x.images && x.images[0] && x.images[0].src) || "",
            type: x.product_type, tags: x.tags || [],
            shoe: (x.options || []).some(function (o) { return /靴/.test((o && o.name) || o || ""); }),
            sizes: vs.filter(function (v) { return v.available; }).length
          };
        });
      }).catch(function () { return []; });
  }
  function choosePicks(owned, cfg, block, need, fallback) {
    var ownedH = {}, ownedK = {}, ownedB = {};
    owned.forEach(function (o) { ownedH[o.h] = 1; ownedK[keyOf(o)] = 1; ownedB[brandKey(o.b)] = 1; });
    var taken = {}, out = [];
    function ok(p) { return p && p.h && p.shoe !== false && p.sizes !== 0 && !ownedH[p.h] && !taken[p.h] && !ownedK[keyOf(p)] && !hasWord(p, block) && !hasWord(p, cfg.nextSkip); }
    function add(list, why) {
      for (var i = 0; i < list.length && out.length < need; i++) {
        if (ok(list[i])) { var p = list[i]; p.why = why; taken[p.h] = 1; out.push(p); return true; }
      }
      return false;
    }
    return Promise.all(cfg.collections.map(loadCollection)).then(function (lists) {
      var all = [], seen = {};
      lists.forEach(function (l) { l.forEach(function (p) { if (!seen[p.h]) { seen[p.h] = 1; all.push(p); } }); });
      var series = [];
      owned.forEach(function (o) { var s = seriesOf(o.t); if (s && series.indexOf(s) < 0) series.push(s); });
      // a 同じシリーズの別の色（新しく買った靴のシリーズから・2足まで・買えるサイズの多い順）
      var same = 0;
      series.slice(0, 3).forEach(function (s) {
        if (same >= 2) return;
        var list = all.filter(function (p) { return nk(seriesOf(p.t)) === nk(s); }).sort(function (x, y) { return y.sizes - x.sizes; });
        if (add(list, "別の色")) same++;
      });
      // b まだ持っていないブランド（コレクションの並び順のまま）
      cfg.brands.forEach(function (b) {
        if (ownedB[brandKey(b)]) return;
        add(all.filter(function (p) { return brandKey(p.b) === brandKey(b); }), "はじめての " + brandName(b));
      });
      // c 予備のおすすめ（テーマの設定で選んだ靴。在庫ありだけがテーマから届く）
      fallback.forEach(function (p) { add([p], "スタッフのおすすめ"); });
      return out.slice(0, need);
    });
  }

  function boot() { var r = document.querySelectorAll(".oo-myshoes"); for (var i = 0; i < r.length; i++) init(r[i]); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
